import React, { FunctionComponent } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const StyledTypography = styled(Typography)({
  textShadow: '1px 1px 3px rgba(0,0,0,0.1)',
});

type UserQuote = {
  author: string;
  authorKey: string;
  color?: 'textPrimary' | 'textSecondary';
};

const UserQuote: FunctionComponent<UserQuote> = ({
  author,
  authorKey,
  color = 'textSecondary',
  children,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box py={1}>
      <StyledTypography variant="body2" color={color}>
        „{formatMessage({ id: `usersQuote.${authorKey}` })}“
      </StyledTypography>
      <Box my={1} />
      <StyledTypography variant="subtitle1" color={color}>
        {author}
      </StyledTypography>
    </Box>
  );
};

export default UserQuote;
